export default "__VITE_ASSET__CqpVSIu___"